import type { ComponentType } from 'react';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/deprecations/no-rll-client-async-experiences
export const PolarisProjectAutomation = lazyForPaint<ComponentType<Record<any, any>>>(
	() => import(/* webpackChunkName: "async-polaris-project-settings-automation" */ './index'),
	{ ssr: false },
);
